<template>
<div  class="main">
  	<public-layout-header />
  <!-- <breadcrumb v-if="show"></breadcrumb> -->
    <HomeLayoutMain></HomeLayoutMain>
  	<public-layout-footer />
</div>
</template>
<script>

import HomeLayoutMain from './HomeLayoutMain.vue'
import PublicLayoutHeader from '@/framework/layout2/PublicLayoutHeader'
import PublicLayoutFooter from '@/framework/layout2/PublicLayoutFooter'
import Breadcrumb from '@/framework/components/Breadcrumb'
import { mapState } from 'vuex'
export default {
  components: {PublicLayoutHeader,PublicLayoutFooter,Breadcrumb,HomeLayoutMain},
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      noticeNumber: state => state.app.noticeNumber,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader,
      show: state=>state.settings.breadcrumbShow,
      userId: state=>state.user.userId,
    }),
  },
  data() {
    return {
    }
  },
  watch: {
  },
  created(){

  },
  mounted() {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.main{
  min-height: calc(100vh - 196px);
  flex:auto !important;
}
  @import "~@/framework/styles/mixin.scss";
  @import "~@/config/styles/variables.scss";
  @import "~@/config/styles/usercenter.scss";
</style>
